import React from "react";
import { Scope as ScopeRocket } from "@rocketseat/unform";

export default function Scope({ path, children }) {

  const _path = path !== null ? path : undefined;

  return <ScopeRocket path={_path}>{children}</ScopeRocket>
}
